import React from "react";
import CartShimmer from "./CartShimmer";

const CartDropDownShimmer = () => {
  return (
    <>
      <div className="p-3">
        <h4 className="font-semibold text-[14px] p-3">My Cart (0)</h4>
      </div>
      <CartShimmer />
      <div className="flex items-start justify-between my-3">
        <div className="w-20 h-4 bg-gray-300 rounded-md animate-pulse"></div>
        <div className="w-12 h-4 bg-gray-300 rounded-md animate-pulse"></div>
      </div>
      <div className="w-full h-10 bg-gray-300 rounded-[20px] animate-pulse"></div>
      <div className="w-full h-10 bg-gray-200 rounded-[20px] animate-pulse mt-2"></div>
    </>
  );
};

export default CartDropDownShimmer;
